import { CheckCircle2, ShieldCheck } from "lucide-react";

const FLEET_FEATURES = [
  "ADA-compliant wheelchair lift & securement systems",
  "Clean, well-maintained, professionally branded vehicles",
  "WMATC certified — authorized for VA, DC & Maryland",
  "Spacious interior for passenger comfort & companions",
  "Trained drivers certified in safe transfers",
];

export default function Fleet() {
  return (
    <section data-testid="fleet-section" id="fleet" className="section-pad bg-white">
      <div className="container-pad mx-auto max-w-7xl">
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-16 items-center">
          <div className="lg:col-span-6 order-2 lg:order-1">
            <div className="grid grid-cols-2 gap-4">
              <div className="relative group col-span-2">
                <div className="absolute -top-3 -left-3 bg-teal-500 text-white px-3 py-1 rounded-full text-[10px] font-bold tracking-widest uppercase shadow-lg z-10">
                  Our Fleet
                </div>
                <img
                  src="https://customer-assets.emergentagent.com/job_comfort-care-booking/artifacts/l5bnk78a_2C3E0AE7-BC6B-41D5-8937-5C064B8E8692.PNG"
                  alt="Comfort Care Transportation branded wheelchair accessible van WMATC 4061"
                  className="w-full h-72 lg:h-80 object-cover rounded-2xl shadow-[0_20px_50px_-20px_rgba(10,25,47,0.3)] group-hover:scale-[1.01] transition duration-500"
                />
              </div>
              <div className="relative group">
                <img
                  src="https://customer-assets.emergentagent.com/job_comfort-care-booking/artifacts/r4712rd0_84EBC7D9-7177-4F0A-9C38-BA0A08E3B4F6.PNG"
                  alt="Comfort Care van interior with deployed wheelchair access ramp"
                  className="w-full h-40 lg:h-48 object-cover rounded-2xl shadow-md group-hover:scale-[1.01] transition duration-500"
                />
              </div>
              <div className="relative group">
                <img
                  src="https://customer-assets.emergentagent.com/job_comfort-care-booking/artifacts/l28afqe7_Screenshot%202026-06-05%20at%209.16.56%E2%80%AFAM.png"
                  alt="Wheelchair user safely boarding accessible van via ramp"
                  className="w-full h-40 lg:h-48 object-cover rounded-2xl shadow-md group-hover:scale-[1.01] transition duration-500"
                />
              </div>
            </div>
          </div>

          <div className="lg:col-span-6 order-1 lg:order-2">
            <span className="eyebrow">
              <span className="w-8 h-px bg-teal-500" />
              Our Fleet
            </span>
            <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-light text-navy tracking-tight mt-5 leading-[1.15]">
              Built for <strong className="font-bold text-teal-600">comfort, dignity & safety.</strong>
            </h2>
            <p className="mt-6 text-base md:text-lg text-navy/65 leading-relaxed font-light">
              Our professionally branded, WMATC-certified wheelchair-accessible vans are equipped with
              hydraulic ramps, four-point securement systems, and spacious interiors so every passenger
              travels with comfort and dignity.
            </p>

            <ul className="mt-8 space-y-3">
              {FLEET_FEATURES.map((f) => (
                <li key={f} className="flex items-start gap-3">
                  <CheckCircle2 className="w-5 h-5 text-teal-500 mt-0.5 shrink-0" />
                  <span className="text-navy/85">{f}</span>
                </li>
              ))}
            </ul>

            <div className="mt-8 inline-flex items-center gap-2 bg-teal-500/10 text-teal-700 rounded-full px-4 py-2">
              <ShieldCheck className="w-4 h-4" />
              <span className="text-sm font-semibold">WMATC 4061 · Certified Tri-State Operator</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
